var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auto-width', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var width = _ref.width;
        return [_c('v-virtual-scroll', _vm._g(_vm._b({
          attrs: {
            "items": _vm.chunks,
            "item-height": width / _vm.n / _vm.aspectRatio + _vm.padding
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var item = _ref2.item,
                index = _ref2.index;
              return _vm._l(item, function (gridItem, i) {
                return index * _vm.n + i < _vm.items.length ? _c('div', {
                  staticClass: "d-inline-block relative",
                  style: {
                    padding: `${_vm.padding}px`,
                    width: `${100 / _vm.n}%`
                  }
                }, [_vm._t("default", null, null, {
                  item: gridItem,
                  index: index * _vm.n + i
                })], 2) : _vm._e();
              });
            }
          }], null, true)
        }, 'v-virtual-scroll', _vm.$attrs, false), _vm.$listeners))];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }